module.exports = require("@wordpress/rich-text");